import api from '@/api/index.js'

const email_templates = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null
  },

  mutations: {
    SET_EMAIL_TEMPLATES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_EMAIL_TEMPLATES_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_EMAIL_TEMPLATES: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_EMAIL_TEMPLATES_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
    SET_EMAIL_TEMPLATE_DELETED: (state, deleted) => {
      if (state.data) {
        state.data = state.data.filter(item => item.id != deleted.id);
      }
      state.updating = false;
    },
    SET_EMAIL_TEMPLATE_UPDATED: (state, changed) => {
      if (state.data) {
        state.data = state.data.filter(item => {
          if (item.id == changed.id) {
            item.created_at = changed.created_at;
            item.description = changed.description;
            item.email_content = changed.email_content;
            item.email_content_html = changed.email_content_html;
            item.email_subject = changed.email_subject;
            item.id = changed.id;
            item.short_name = changed.short_name;
            item.updated_at = new Date();
          }
          return item
        });
      }
      state.updating = false;
    },
  },

  actions: {
    LoadEmailTemplates({commit}) {
      commit('SET_EMAIL_TEMPLATES_ERROR', null)
      commit('SET_EMAIL_TEMPLATES_LOADING', true)
      return api.get(`email-templates?limit=0&offset=0`)
        .then((response) => {
          commit('SET_EMAIL_TEMPLATES', response)
        })
        .catch((error) => {
          commit('SET_EMAIL_TEMPLATES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateEmailTemplate({commit}, payload) {
      commit('SET_EMAIL_TEMPLATES_UPDATING', true);
      commit('SET_EMAIL_TEMPLATES_ERROR', null)
      commit('SET_ERROR', null)
      return api.post(`email-templates`, payload)
        .then((response) => {
          commit('SET_EMAIL_TEMPLATES_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_EMAIL_TEMPLATES_ERROR', error);
          commit('SET_EMAIL_TEMPLATES_UPDATING', false);
        })
    },
    UpdateEmailTemplate({commit}, payload) {
      commit('SET_EMAIL_TEMPLATES_UPDATING', true);
      commit('SET_EMAIL_TEMPLATES_ERROR', null)
      commit('SET_ERROR', null)
      return api.put(`email-templates/${payload.id}`, payload)
        .then((response) => {
          commit('SET_EMAIL_TEMPLATE_UPDATED', payload);
        })
        .catch((error) => {
          commit('SET_EMAIL_TEMPLATES_ERROR', error);
          commit('SET_EMAIL_TEMPLATES_UPDATING', false);
        })
    },
    DeleteEmailTemplate({commit}, payload) {
      commit('SET_EMAIL_TEMPLATES_UPDATING', true);
      commit('SET_EMAIL_TEMPLATES_ERROR', null)
      commit('SET_ERROR', null)
      return api.delete(`email-templates/${payload.id}`)
        .then((response) => {
          commit('SET_EMAIL_TEMPLATE_DELETED', payload);
        })
        .catch((error) => {
          commit('SET_EMAIL_TEMPLATES_ERROR', error);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMAIL_TEMPLATES_UPDATING', false);
        })
    },
  },
}

export default email_templates
